const STATIC_ASSETS_HOST = 'https://static-assets.vinterior.co'

export function myListingsIconUrl (fileName) {
  return `${STATIC_ASSETS_HOST}/icons/my-listings-page/${fileName}`
}
